<template>
  <v-app>
    <Navigation v-if="isLoggedIn" />
    <Toolbar :event="event" v-on:open-profile-dialog="userProfileDialog = true"/>

    <v-content>
      <router-view/>
    </v-content>
    <v-btn icon fixed bottom right color="primary" @click="$vuetify.goTo('body')"><v-icon>fal fa-chevron-up</v-icon></v-btn>
    <v-dialog v-model="$store.state.loader" hide-overlay persistent width="300">
      <v-card>
        <v-card-text class="pa-4 text-xs-center">
          <v-progress-circular size="128" indeterminate color="primary"></v-progress-circular>
          <p class="mt-4">Anfrage wird bearbeitet</p>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-dialog v-model="userProfileDialog" max-width="400">
      <v-card>
        <v-card-text>
          <Profile />
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn @click="userProfileDialog = false" color="primary" flat>Schließen</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-app>
</template>

<script>
  import Toolbar from './components/Toolbar'
  import Navigation from "./components/Navigation";
  import Profile from "./components/Profile";

export default {
  name: 'App',
  components: {
    Profile,
    Navigation,
    Toolbar
  },
  computed: {
    event () {
      return this.$store.state.event
    },
    isLoggedIn () {
      return this.$store.getters.isLoggedIn
    },
    user () {
      return this.$store.state.user
    }
  },
  created () {
    if (this.$route.path === '/home' && !this.isLoggedIn) {
      this.$router.push('/')
    }

    this.$store.dispatch('loadSportabelEvents')

    let event = localStorage.getItem('event')
    if (this.isLoggedIn && event !== undefined) {
      this.$store.dispatch('loadEvent', event)
    }
  },
  data: function () {
    return {
      userProfileDialog: false
    }
  },
  methods: {
    logout: function () {
      this.$store.dispatch('logout')
        .then(() => {
          this.$router.push('/login')
        })
    }
  }
}
</script>
